import { t, Trans } from '@lingui/macro'
import { Paper, Typography } from '@material-ui/core'
import { css } from 'emotion'
import React, { useEffect } from 'react'
import { RouteComponentProps } from 'react-router'

import { CenterContainer } from '../atoms/CenterContainer'
import { LoaderSpinner } from '../atoms/LoaderSpinner'
import { useRoot } from '../atoms/RootProvider'
import { useSnackBar } from '../hooks/useSnackBar'
import { i18n } from '../i18n'
import { LoginForm } from '../molecules/LoginForm'
import { GuestLayout } from '../organisms/GuestLayout'

interface IProps extends RouteComponentProps {}

const paper = css`
  position: fixed;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 12rem;
  top: 30%;
  padding: 1rem;
  max-width: 28rem;
`

export const AuthPage: React.FC<IProps> = ({ history }) => {
  const { auth } = useRoot()
  const { enqueueError } = useSnackBar()

  const onHandleAuth = async (email: string) => {
    try {
      await auth.handleAuthentication(email)
      const url = new URL(window.location.href)
      const origin = url.searchParams.get('o')
      history.replace(origin || '/')
    } catch (err) {
      enqueueError(`${err.message} (${err.code})`)
      history.replace('/login')
    }
  }

  useEffect(
    () => {
      if (auth.authEmail) {
        onHandleAuth(auth.authEmail)
      }
    },
    [auth.authEmail],
  )

  if (!auth.authEmail) {
    return (
      <GuestLayout title={i18n._(t`Potvrzení přihlášení`)}>
        <CenterContainer>
          <Paper className={paper}>
            <Typography variant="body1" gutterBottom={true}>
              <Trans>
                Zdá se, že jste odkaz použili v jiném prohlížeči.
                <br />
                Prosím vyplňte znovu stejný email pro ověření přihlášení.
              </Trans>
            </Typography>
            <LoginForm
              onSubmit={onHandleAuth}
              buttonText={i18n._(t`Přihlásit do aplikace`)}
            />
          </Paper>
        </CenterContainer>
      </GuestLayout>
    )
  }
  return <LoaderSpinner />
}
